/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Applicant_RequirementsInputs */

const en_job_form_applicant_requirements = /** @type {(inputs: Job_Form_Applicant_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicant Requirements`)
};

const de_job_form_applicant_requirements = /** @type {(inputs: Job_Form_Applicant_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anforderungen an Bewerber`)
};

/**
* | output |
* | --- |
* | "Applicant Requirements" |
*
* @param {Job_Form_Applicant_RequirementsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_applicant_requirements = /** @type {((inputs?: Job_Form_Applicant_RequirementsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Applicant_RequirementsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_applicant_requirements(inputs)
	return en_job_form_applicant_requirements(inputs)
});